<template>
	<v-container fluid>
		<v-row
			justify = "center"
		>
			<v-col
				xl 	 = "10"
				lg 	 = "11"
				md 	 = "12"
				sm 	 = "12"
				xs 	 = "12"
				cols = "12"
			>
				
			
				<v-card outlined>
					<v-card-title
						class  = "justify-center body-1 text-uppercase font-weight-bold secondary pa-1 white--text"
						
					>	
						<v-icon 
							small 
							color  = "white"
							class  = "ml-1"
							@click = "$router.back()"
						>
							mdi-arrow-left-circle
						</v-icon>

						<v-spacer></v-spacer>
						<v-icon 
							small 
							color  = "primary"
							class  = "mx-2"
						>
							mdi-cctv
						</v-icon>
						<span 
							v-text = "$ml.get('device')"
						></span>
						<v-spacer></v-spacer>

					</v-card-title>
					<v-spacer></v-spacer>
					<v-card-text
						class = "pa-1 "
					>				
						<v-row
							dense
						>
							<v-col 
								xl 	   = "2"
								lg 	   = "3"
								md 	   = "3"
								sm 	   = "3"
								xs 	   = "3"
								cols   = "3"
								v-show = "show.add_devs"
							>
								<v-card >
									<v-card-title
										class = "pa-1 pl-2 secondary body-2 white--text"
									>
										<v-icon
											x-small
											color = "white"
											class = "mx-1"
										>
											mdi-form-select
										</v-icon>
										{{ $ml.get('options') }}
									</v-card-title>
									<v-card-text class = "pa-1 pt-0">
										<v-list dense>

			
											<v-list-item-group
											 	color = "primary"
											>
												<template
													v-for = "(btn_device, btn_index) of get_type_devices"
												>	
													<v-card outlined
													:key="'bn'+btn_index">

													<v-list-item 
														class  = "primary"
														:key   = "btn_index"	
														@click = "redirect(btn_device.btn_action ,btn_device.key)"				
													>				
													 	<v-list-item-icon
													 		class = "mx-0"
													 	>
											            	<v-icon 
											            		small
											            		color  = "white"
											            		v-text = "btn_device.icon"
											            	></v-icon>
											          	</v-list-item-icon>													
														<v-list-item-title
															class  = "white--text"
															v-text = "btn_device.title"
														></v-list-item-title>
													</v-list-item>
												</v-card>
												</template>
											</v-list-item-group>
										</v-list>
									</v-card-text>
								</v-card>
										
							</v-col>
							<v-col>
								<v-toolbar						    		
						    		dense
						    		height = "25"
						    		class  = "secondary white--text"
						    	>
					    			<v-icon
										small
										color = "white"
										class = "mr-1"
									>
										mdi-view-list
									</v-icon>
						    		<v-toolbar-title  
						    			class = "body-2"
						    		>	
						    			{{ $ml.get('registered_devices') }}
						    		</v-toolbar-title>
						    		<v-spacer></v-spacer>
						    		<v-btn-toggle
						    			v-show = "show.selecteds"
						    		>
						    			
							    		<template
							    			v-for = "(item_option, idx_option) of options_device"
							    		>	
							    			<v-tooltip
							    				bottom
												:key="'tooltip'+idx_option"
								    			v-if   = "item_option.type == 'btn'"
							    			>
							    				
								    			<template v-slot:activator = "{ on }">							    			
								    			<v-btn
								    				x-small
								    				v-on   = "on"
								    				:key   = "idx_option"
								    				:color = "item_option.color" 
								    			>
								    				<v-icon
								    					x-small						    					
								    				>
								    					{{ item_option.icon }}
								    				</v-icon>
								    			</v-btn>
								    			</template>
								    			<span>
								    				{{ $ml.get(item_option.text) }}
								    			</span>
							    			</v-tooltip>
							    			<v-menu 
							    				bottom 
												:key="'men'+idx_option"
												offset-y 
												:close-on-content-click = "true"
									    		v-else-if 	 	= "item_option.type == 'file'"
							    			>	
												
								    			<template v-slot:activator = "{ on : menu}">									    					

								    				<v-tooltip
								    					bottom									    				
								    				>
							    						<template 
							    							v-slot:activator = "{ on : tooltip}"
							    						>		
									    				
											    			<v-btn
											    				x-small
											    				:key    = "idx_option"
					    										v-on 	= "{...tooltip, ...menu}"	
											    				:color  = "item_option.color" 
											    				
											    			>
											    				<v-icon
											    					x-small						    					
											    				>
											    					{{ item_option.icon }}
											    				</v-icon>
											    			</v-btn>
											    		</template>
											    		<span>
								    						{{ $ml.get(item_option.text) }}
											    			
											    		</span>
											    	</v-tooltip>
							    				</template>
										    		<!-- hide-input -->
									    		<v-list 
									    			dense
									    			class = "pa-0"

									    		>
									    			<v-list-item>
									    				<v-list-item-content
											    			class = "pa-0"

									    				>
									    					 <v-list-item-title>
									    					 	
									    			
										    			<v-file-input 
											    			dense
											    			hide-details
											    			class 		 	= "pa-0 success pa-0"
											    			@change 	 	= "actions(item_option.action)"
											    			v-model 	 	= "info_import"
											    			:prepend-icon 	= "item_option.icon"
											    			placeholder 	= "import"
										    			>								    			
											    			<!-- style 			= "font-size: 10px; height: 20px;" -->
										    			</v-file-input>
									    					 </v-list-item-title>
									    				</v-list-item-content>
									    			</v-list-item>
									    		</v-list>
							    			</v-menu>
							    		</template>
						    		</v-btn-toggle>
						    	</v-toolbar>
								<v-divider></v-divider>
								<v-data-table
									dense
								    fixed-body
								    fixed-header
								   	:show-select 		 = "show.selecteds"
									:headers 			 = "header_table"
									:items 				 = "render_list"
									class 				 = "elevation-5"
								   	loading-text 		 = "Loading... Please wait"
								   	v-model 			 = "device_selecteds"
								   	:loading 			 = "loading"
								    item-key 			 = "index"
								    :height 			 = "layout_height + 'px'"
									:options.sync 		 = "options"
								   	:server-items-length = "total"
								   	:custom-filter 	 = "filterAllColumns"
								   	:footer-props 		 = "{
								   		showFirstLastPage   : true,
								   		itemsPerPageOptions : [total],  // 15, 30
								   		showCurrentPage 	: true,
								   		itemsPerPageText 	: ''
								   	}"
								>
								    <!-- rowsPerPageText: [30] -->
								    <template v-slot:top >
								    	<v-row 
								    		no-gutters
								    	>
								    		<v-col
								    			cols = "8"
								    		>
								    			<searcher
													
													:info_to_component = "item_search"
													:info_to_component1 = "select_type_device"
													:info_to_list  	   = "list"
													@receive_info	   = "listed = $event"
												></searcher>
								    		</v-col>
								    		<v-col>
								    			<v-select
								    				dense
								    				outlined
								    				hide-details
								    				small-chips
								    				class 		= "mt-1"
								    				v-model 	= "select_type_device"
								    				:items  	= "list_types_devices"
								    				:label  	= "$ml.get('type_device')"
								    				item-text 	=  "title"
								    				item-value 	= "key"
								    			></v-select>
								    				<!-- @change 	= "actions('select_type_device')" -->
								    		</v-col>
								    	</v-row>
								    </template>
									<template v-slot:item.name = "{ item }">
										<!-- Sin tooltip para dispositivos no-cámara -->
										<span v-if="item.type !== 'IP_CAM'" style="cursor: default">
											{{ item.name }}
										</span>
										<!-- Tooltip solo para IP_CAM -->
										<v-tooltip v-else bottom>
											<template v-slot:activator = "{ on, attrs }">
												<span
													v-bind = "attrs"
													v-on   = "on"
													@mouseenter = "onHoverName(item)"
													style = "cursor: default"
												>
													{{ item.name }}
												</span>
											</template>
											<!-- Tooltip para IP_CAM con snapshot -->
											<div
												style = "width: 220px; height: 124px; display:flex; align-items:center; justify-content:center;"
											>
												<v-progress-circular
													v-if   = "item.snapshot_loading"
													indeterminate
													color  = "primary"
													size   = "20"
													width  = "2"
												></v-progress-circular>
												<img
													v-else-if = "item.snapshot_src"
													:src      = "item.snapshot_src"
													alt       = "snapshot"
													style     = "max-width:100%; max-height:100%;"
												/>
												<span v-else>
													{{ $ml.get('n_a') }}
												</span>
											</div>
										</v-tooltip>
									</template>
									<template v-slot:item.status = "{ item }">
										<v-progress-circular
											v-if = "item.onvif_loading || (item.relay_loading && item.type === 'PERIPHERAL' && item.type_peripheral === 'iot_relay')"
											indeterminate
											color  = "primary"
											size   = "14"
											width  = "2"
										></v-progress-circular>
										<v-tooltip v-else bottom>
											<template v-slot:activator = "{ on, attrs }">
												<v-chip
													v-bind = "attrs"
													v-on   = "on"
													x-small
													:color = "item.status_color || 'secondary'"
													label
												>
													{{ $ml.get(item.status_key || 'n_a') }}
												</v-chip>
											</template>
											<div style="max-width:300px; white-space: normal;">
												<!-- Información específica para iot_relay -->
												<template v-if="item.type === 'PERIPHERAL' && item.type_peripheral === 'iot_relay'">
													<div style="font-weight: bold; margin-bottom: 6px;">{{ item.name }}</div>
													<div style="margin-bottom: 4px;">
														<strong>{{ $ml.get('status') || 'Status' }}:</strong> {{ $ml.get(item.status_key || 'n_a') }}
													</div>
													<div v-if="item.relay_inputs_count !== undefined && item.relay_inputs_count !== null" style="margin-top: 6px;">
														<strong>{{ $ml.get('inputs') || 'Inputs' }}:</strong> {{ item.relay_inputs_count }}
														<span v-if="item.relay_inputs_list && item.relay_inputs_list.length > 0">
															({{ item.relay_inputs_list.join(', ') }})
														</span>
													</div>
													<div v-if="item.relay_relays_count !== undefined && item.relay_relays_count !== null" style="margin-top: 4px;">
														<strong>{{ $ml.get('relays') || 'Relays' }}:</strong> {{ item.relay_relays_count }}
														<span v-if="item.relay_relays_list && item.relay_relays_list.length > 0">
															({{ item.relay_relays_list.join(', ') }})
														</span>
													</div>
													<div v-if="item.ip" style="margin-top: 4px;">
														<strong>IP:</strong> {{ item.ip }}
													</div>
													<div v-if="item.serial" style="margin-top: 2px;">
														<strong>{{ $ml.get('serial') || 'Serial' }}:</strong> {{ item.serial }}
													</div>
												</template>
												<!-- Información para otros dispositivos -->
												<template v-else>
													<template v-if="item.status_detail">
														<div v-if="item.status_detail.type">
															<strong>
																{{ $ml.get((item.status_detail.errType || item.status_detail.type).toLowerCase()) || item.status_detail.type }}
															</strong>
														</div>
														<div v-if="item.status_detail.message" v-html="item.status_detail.message"></div>
														<div v-else>
															{{ $ml.get((item.status_detail.errType || item.status_detail.type).toLowerCase()) || $ml.get('n_a') }}
														</div>
														<div v-if="item.status_detail.status">HTTP: {{ item.status_detail.status }}</div>
													</template>
													<template v-else>
														{{ $ml.get('n_a') }}
													</template>
												</template>
											</div>
										</v-tooltip>
									</template>
									<template v-slot:item.resolution = "{ item }">
										<span>{{ item.resolution || $ml.get('n_a') }}</span>
									</template>
									<template v-slot:item.fps = "{ item }">
										<span>{{ item.fps_display || $ml.get('n_a') }}</span>
									</template>
									<template v-slot:item.codec = "{ item }">
										<span>{{ item.codec || $ml.get('n_a') }}</span>
									</template>
									<template v-slot:item.bitrate = "{ item }">
										<span>{{ item.bitrate_display || $ml.get('n_a') }}</span>
									</template>
									<template 
										v-slot:item.actions = "{ item }"	
									>
										<v-btn
											x-small
											color  = "primary"
											@click = "redirect_setting(item)"
											v-show = "show.edit_device"
										>
											<v-icon
												x-small
												v-text = "'mdi-pencil'"
											></v-icon>
										</v-btn>	
										<v-btn
											x-small
											class  = "mx-1"
											color  = "error"
											v-show = "show.delete_device"											
											@click = "actions('confirm_delete', item)"
										>
											<v-icon
												x-small
												v-text = "'mdi-delete'"
											></v-icon>
										</v-btn>							
									</template>
									<template v-slot:item.type = "{ item }">
										<span> {{ item.type === 'ACCESS_CONTROL' ? 'ACCESS CONTROL' : (item.type ? item.type : 'IP CAM') }}</span>
									</template>
									<template
										v-slot:item.limited = "{ item}"
									>
										<v-chip
											x-small
											:color = "item && item.limit ? 'success' : 'secondary'"
										>
											{{ item.limited }}
										</v-chip>

									</template>
									<template
										v-slot:item.space = "{ item }"
									>
										<!-- <v-chip
											x-small
											:color = "item && item.space  && item.space_color ? item.space_color :  'secondary'"
										>
											{{ item.space }}
										</v-chip> -->
										<v-tooltip bottom >
											<template
												v-slot:activator = "{ on }"
											>
													
												<v-progress-linear
									    			reactive
									    			:color 		   = "item && item.space  && item.space_color ? item.space_color :  'secondary'"
									    			:buffer-value  = "item.space ? 100 : 0"
									    			:value 		   = "item.space"
									    			height 		   = "14"
									    			style 		   = "width: 100%; margin-top:0px"
									    			v-on		   = "on"
									    			
								    			>
													<v-icon
														small
														class = "mx-2"
													>
														mdi-video
													</v-icon>
													<strong 
														class = "pa-0 ma-0 caption"
													>
														{{ (item.space) }}
													</strong>
								    			</v-progress-linear>
											</template>
											<span v-show = "item.used">
												Used : {{ item.used }}
											</span>
										</v-tooltip>
									</template>
									<template
										v-slot:item.manager_id = "{ item }"
									>
										<v-chip
											x-small
											label
											:color = "item.color_workstation"
										>
											
											{{ item.workstation }}
										</v-chip>
									</template>
								</v-data-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>
<script>
	import axios 	from 'axios'
	import EventBus from '@/event-bus'
	import searcher from "@/components/info/searcher.vue"
	import { fetchOnvifMediaProfiles } from '../services/onvifApi.js'
	import AccessControlService, { sanitizeAccessControlDevice } from '@/services/accessControl.service.js'

	export default{
		name 		: 'add_device',
		components  : {
			searcher,		
		}, // components
		data: (vm) => ({
			// table
			header_table: [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('type'), value: 'type' },
				{ text: vm.$ml.get('status'), value: 'status', align: 'center' },
				{ text: vm.$ml.get('ip'), value: 'ip' },
				{ text: 'Resolution', value: 'resolution', filterable: true },
				{ text: 'FPS', value: 'fps', filterable: true },
				{ text: 'Codec', value: 'codec', filterable: true },
				{ text: 'Bitrate', value: 'bitrate', filterable: true },
				{ text: vm.$ml.get('workstation'), value: 'manager_id' },			
				{ text: vm.$ml.get('limit'), value: 'limited' },

				
			],
			options : { itemsPerPage: 30 },
			total 	: 1,
			list 	: [],
			listed 	: [],
			is_loading_list : false, // Bandera para evitar llamadas múltiples
			initial_load_done : false, // Bandera para indicar si ya se hizo la carga inicial
			current_loading_page : null, // Página que se está cargando actualmente
			processed_ip_cam_devices : new Set(), // Rastrear dispositivos ip_cam que ya fueron procesados
			// sidebar 
			type_devices: [
				{ 
					key  		: 'ip_cam',
					title  		: 'IP CAM', 
					color 		: 'primary', 
					enable 		: true, 
					btn_action 	: 'new_device', 
					icon  		: 'mdi-video-plus',
				},
				{ 
					key  		: 'new_peripheral',
					title  		: 'PERIPHERALS', 
					color 		: 'primary', 
					enable 		: true, 
					btn_action 	: 'new_peripheral', 
					icon  		: 'mdi-diving-scuba',
				},
				{
					key  		: 'ACCESS_CONTROL',
					title  		: 'ACCESS CONTROL',
					color 		: 'primary',
					enable 		: true,
					btn_action 	: 'new_access_control',
					icon  		: 'mdi-door-closed-lock',
				},
				{ 
					title: 'WEBCAM', 
					color: 'info', 
					enable: false 
				},
				{ 
					title: 'DVR', 
					color: 'secondary', 
					enable: false 
				},
			], 
			layout_height : 400,
			curren_route  : true,
			info_del 	  : null,
			loading  	  : false,
			item_search   : {
				key 		 : 'search',
				text 		 : 'search',
				placeholder  : 'device',
				list 		 : 'list_devices',
				key_list	 : 'deviceId',
				text_list 	 : 'name',
				type 		 : 'field_searcher',
				key_search   : 'name',
				key_search_1 : 'deviceId',
				search_all_columns : true, // Nueva propiedad para buscar en todas las columnas
				visible 	 : true,
				cols 		 : {
					col : 2,
				},
			},
			search 		  : '', 
			bus  		  : {},			
			permission 	  : {
				"roles": [1, 2]
			},
			options_device : [
				{
					key 	: 'backup',
					type 	: 'btn',
					action  : 'backup',
					text 	: 'backup',
					icon 	: 'mdi-folder-upload',
					color 	: 'primary',
				},
				{
					key 	: 'restore_backup',
					type 	: 'file',
					action  : 'restore_backup',
					text 	: 'restore_backup',
					icon 	: 'mdi-file-import',
					color 	: 'success',
				},
				{
					key 	: 'del_devices',
					type 	: 'btn',
					action  : 'confirm_del_devices',
					text 	: 'delete_devices',
					icon 	: 'mdi-trash-can',
					color 	: 'error',
				},
			],
			device_selecteds: [],
			show 			: {
				select 	  		: false,
				selecteds 		: false,
				add_devs  		: false,
				edit_device		: true,
				delete_device 	: true,
			},
			info_import 		: null,
			select_type_device 	: "all",
			list_types_devices  : [
				{
					key 	: "all",
					title 	: "All", 
				},
				{ 
					key  		: 'IP_CAM',
					title  		: 'IP CAM',
				},
				{ 
					key  		: 'PERIPHERAL',
					title  		: 'PERIPHERALS', 
				},
				{
					key  		: 'ACCESS_CONTROL',
					title  		: 'ACCESS CONTROL',
				}
			],

		}), // data

		created(){
			if (this.$store.getters["auth/permission"](this.$route.name || "device", "can_edit", "device")){ // this.$Helper.current_auth_user(this.currentUser, this.permission)
				this.header_table.push({ text: this.$ml.get('actions'), value: 'actions', align: 'center' });
				this.show.edit_device = true;
			}else{
				this.show.edit_device = false;

			}
			if (this.$store.getters["auth/permission"](this.$route.name || "device", "can_delete", "device")) {
				this.show.delete_device = true;
				if (!this.$store.getters["auth/permission"](this.$route.name || "device", "can_edit", "device")) {
					this.header_table.push({ text: this.$ml.get('actions'), value: 'actions', align: 'center' });
				}

			}else{
				this.show.delete_device = false;				
			}
			if (this.$router.currentRoute.name == 'device' && this.$store.getters["auth/permission"](this.$route.name || "device", "can_add", "device")) {
				this.show.add_devs  = true; 
			}
		}, // created

		watch: {
			options: {
				handler(newVal, oldVal){
					// No ejecutar si aún no se completó la carga inicial
					if (!this.initial_load_done) {
						return;
					}
					
					// Solo ejecutar si no está cargando
					if (this.is_loading_list) {
						return;
					}
					
					// Solo ejecutar si cambió la página o itemsPerPage (no otros cambios internos del v-data-table)
					if (oldVal && (
						(newVal.page !== oldVal.page) || 
						(newVal.itemsPerPage !== oldVal.itemsPerPage)
					)) {
						this.get_list();
					}
				}, 
				deep: true,
				immediate: false
			}, // options

		}, // watch 

		methods: {
			extractIpFromRtsp(url){
				if (!url || typeof url !== 'string') return '';
				try{
					// scheme://[user[:pass]@]host[:port]/path...
					const re = new RegExp("(https?|rtsp|qvmc|rtmp):\\/\\/(?:([^\\s@\\/]+?)@)?\\[?([^\\s\\/:\\]]+)\\]?");
					const match = re.exec(url);
					if (match && match[3]) {
						return match[3];
					}
				}catch(e){}
				return '';
			}, // extract ip from rtsp
			extractConnFromRtsp(url){
				if (!url || typeof url !== 'string') return null;
				try{
					const re = new RegExp("^rtsp:\\/\\/(?:([^:@\\/]+)(?::([^@\\/]*))?@)?\\[?([^\\/:\\]]+)\\]?(?::(\\d+))?");
					const m  = re.exec(url);
					if (!m) return null;
					const username = m[1] || '';
					const password = m[2] || '';
					const host     = m[3] || '';
					const rtspPort = m[4] ? parseInt(m[4], 10) : null; // no usado para ONVIF
					// Para ONVIF asumimos HTTP 80 si no se conoce otro
					const port     = 80;
					const secure   = false;
					return { username, password, host, port, secure };
				}catch(e){ return null; }
			}, // extract connection from rtsp
			arrayBufferToBase64(buffer){
				try{
					let binary = '';
					const bytes = new Uint8Array(buffer);
					const len = bytes.byteLength;
					for (let i = 0; i < len; i++) {
						binary += String.fromCharCode(bytes[i]);
					}
					return window.btoa(binary);
				}catch(e){ return ''; }
			},
			onHoverName(item){
				if (!item) return;
				// Solo para dispositivos tipo IP_CAM, no para PERIPHERAL
				if (item.type !== 'IP_CAM') {
					return;
				}
				
				// Si está cargando, no hacer nada
				if (item.snapshot_loading) return;
				
				// Si ya hay imagen, verificar si han pasado más de 3 segundos
				if (item.snapshot_src && item.snapshot_timestamp) {
					const timeSinceLastFetch = Date.now() - item.snapshot_timestamp;
					if (timeSinceLastFetch < 3000) {
						// Menos de 3 segundos, no hacer nueva solicitud
						return;
					}
				}
				
				this.$set(item, 'snapshot_loading', true);
				this.fetchSnapshotForDevice(item);
			},
			async fetchSnapshotForDevice(dev){
				try{
					if (!dev) { return; }
					// No hacer consulta a snapshot si el dispositivo no es cámara
					if (dev.type !== 'IP_CAM') {
						this.$set(dev, 'snapshot_loading', false);
						return;
					}
					const rtsp = dev.rtsp || '';
					if (!rtsp) {
						this.$set(dev, 'snapshot_loading', false);
						return;
					}
					const api = this.$URL + '/api/v1/device/snapshot';
					const body = { rtspUrl: rtsp };
					const res = await this.$axios.post(api, body);
					if (res && res.data && res.data.base64) {
						this.$set(dev, 'snapshot_src', 'data:image/jpeg;base64,' + res.data.base64);
						this.$set(dev, 'snapshot_timestamp', Date.now());
					}
				}catch(e){
					// ignore
				}finally{
					this.$set(dev, 'snapshot_loading', false);
				}
			},
			_formatOnvifVideoMeta(meta){
				if (!meta) return '';
				const parts = [];
				if (meta.width && meta.height) parts.push(`${meta.width}x${meta.height}`);
				if (meta.fps) parts.push(`${meta.fps}fps`);
				if (meta.encoding) parts.push(`${String(meta.encoding).toUpperCase()}`);
				if (meta.bitrateKbps) parts.push(`${meta.bitrateKbps}kbps`);
				return parts.join(', ');
			},
			_formatMetadataConfig(metadata){
				if (!metadata) return '';
				const parts = [];
				if (metadata.resolution) {
					parts.push(metadata.resolution);
				} else if (metadata.width && metadata.height) {
					parts.push(`${metadata.width}x${metadata.height}`);
				}
				if (metadata.fps_recent && metadata.fps_recent > 0) {
					parts.push(`${metadata.fps_recent}fps`);
				} else if (metadata.fps && metadata.fps > 0) {
					parts.push(`${metadata.fps}fps`);
				}
				if (metadata.format) {
					parts.push(metadata.format.toUpperCase());
				}
				if (metadata.bitrate_kbps && metadata.bitrate_kbps > 0) {
					parts.push(`${metadata.bitrate_kbps}kbps`);
				}
				return parts.length > 0 ? parts.join(', ') : '';
			},
			handleMetadataUpdate(metadata){
				if (!metadata || !metadata.deviceId) return;
				
				// Buscar el dispositivo para verificar su tipo
				const checkDeviceIdx = this.listed.findIndex(dev => dev && dev.deviceId === metadata.deviceId);
				if (checkDeviceIdx >= 0) {
					const checkDevice = this.listed[checkDeviceIdx];
					// Si es tipo ip_cam y ya fue procesado, no ejecutar nuevamente
					if (checkDevice.type === 'IP_CAM' || checkDevice.type === 'ip_cam') {
						if (this.processed_ip_cam_devices.has(metadata.deviceId)) {
							return;
						}
						// Marcar como procesado
						this.processed_ip_cam_devices.add(metadata.deviceId);
					}
				}
				
				// Extraer y formatear los datos de metadata
				const resolution = metadata.resolution || (metadata.width && metadata.height ? `${metadata.width}x${metadata.height}` : '');
				const fps = metadata.fps_recent && metadata.fps_recent > 0 ? metadata.fps_recent : (metadata.fps && metadata.fps > 0 ? metadata.fps : null);
				const fpsDisplay = fps ? `${fps.toFixed(2)}fps` : '';
				const codec = metadata.format ? metadata.format.toUpperCase() : '';
				const bitrate = metadata.bitrate_kbps && metadata.bitrate_kbps > 0 ? metadata.bitrate_kbps : null;
				const bitrateDisplay = bitrate ? `${bitrate.toFixed(2)}kbps` : '';
				
				// Buscar el dispositivo en la lista
				const deviceIdx = this.listed.findIndex(dev => dev && dev.deviceId === metadata.deviceId);
				if (deviceIdx >= 0) {
					const device = this.listed[deviceIdx];
					
					// Actualizar campos individuales para filtrado
					this.$set(device, 'resolution', resolution);
					this.$set(device, 'fps', fps);
					this.$set(device, 'fps_display', fpsDisplay);
					this.$set(device, 'codec', codec);
					this.$set(device, 'bitrate', bitrate);
					this.$set(device, 'bitrate_display', bitrateDisplay);
					
					// Mantener config_text para compatibilidad
					const configText = this._formatMetadataConfig(metadata);
					if (configText) {
						this.$set(device, 'config_text', configText);
					}
					
					// Actualizar status basado en el status de metadata
					if (metadata.status) {
						const statusLower = metadata.status.toLowerCase();
						let statusDetail = {
							type: metadata.status,
							message: ''
						};
						
						// Construir mensaje detallado para el tooltip
						const detailParts = [];
						if (metadata.name) {
							detailParts.push(`Device: ${metadata.name}`);
						}
						if (metadata.status) {
							detailParts.push(`Status: ${metadata.status}`);
						}
						if (resolution) {
							detailParts.push(`Resolution: ${resolution}`);
						}
						if (fps) {
							detailParts.push(`FPS: ${fps}`);
						}
						if (codec) {
							detailParts.push(`Codec: ${codec}`);
						}
						if (bitrate) {
							detailParts.push(`Bitrate: ${bitrate} kbps`);
						}
						if (metadata.frame_count !== undefined) {
							detailParts.push(`Frames: ${metadata.frame_count}`);
						}
						
						statusDetail.message = detailParts.join('<br>');
						
						// Estados activos: connected, streaming, active -> verde (success)
						if (statusLower === 'connected' || statusLower === 'streaming' || statusLower === 'active') {
							this.$set(device, 'status_key', 'online');
							this.$set(device, 'status_text', this.$ml.get('online'));
							this.$set(device, 'status_color', 'success'); // Verde cuando está activo
							this.$set(device, 'status_detail', statusDetail);
						} else if (statusLower === 'disconnected') {
							this.$set(device, 'status_key', 'offline');
							this.$set(device, 'status_text', this.$ml.get('offline'));
							this.$set(device, 'status_color', 'error');
							this.$set(device, 'status_detail', statusDetail);
						} else {
							this.$set(device, 'status_key', statusLower);
							this.$set(device, 'status_text', this.$ml.get(statusLower) || metadata.status);
							this.$set(device, 'status_color', 'warning');
							this.$set(device, 'status_detail', statusDetail);
						}
					}
					
					// Actualizar también en this.list si existe
					const listIdx = this.list.findIndex(dev => dev && dev.deviceId === metadata.deviceId);
					if (listIdx >= 0) {
						const listDevice = this.list[listIdx];
						
						// Actualizar campos individuales para filtrado
						this.$set(listDevice, 'resolution', resolution);
						this.$set(listDevice, 'fps', fps);
						this.$set(listDevice, 'fps_display', fpsDisplay);
						this.$set(listDevice, 'codec', codec);
						this.$set(listDevice, 'bitrate', bitrate);
						this.$set(listDevice, 'bitrate_display', bitrateDisplay);
						
						if (configText) {
							this.$set(listDevice, 'config_text', configText);
						}
						if (metadata.status) {
							const statusLower = metadata.status.toLowerCase();
							let statusDetail = {
								type: metadata.status,
								message: ''
							};
							
							const detailParts = [];
							if (metadata.name) detailParts.push(`Device: ${metadata.name}`);
							if (metadata.status) detailParts.push(`Status: ${metadata.status}`);
							if (resolution) detailParts.push(`Resolution: ${resolution}`);
							if (fps) detailParts.push(`FPS: ${fps}`);
							if (codec) detailParts.push(`Codec: ${codec}`);
							if (bitrate) detailParts.push(`Bitrate: ${bitrate} kbps`);
							if (metadata.frame_count !== undefined) {
								detailParts.push(`Frames: ${metadata.frame_count}`);
							}
							
							statusDetail.message = detailParts.join('<br>');
							
							// Estados activos: connected, streaming, active -> verde (success)
							if (statusLower === 'connected' || statusLower === 'streaming' || statusLower === 'active') {
								this.$set(listDevice, 'status_key', 'online');
								this.$set(listDevice, 'status_text', this.$ml.get('online'));
								this.$set(listDevice, 'status_color', 'success'); // Verde cuando está activo
								this.$set(listDevice, 'status_detail', statusDetail);
							} else if (statusLower === 'disconnected') {
								this.$set(listDevice, 'status_key', 'offline');
								this.$set(listDevice, 'status_text', this.$ml.get('offline'));
								this.$set(listDevice, 'status_color', 'error');
								this.$set(listDevice, 'status_detail', statusDetail);
							}
						}
					}
				}
			},
			_parseProfilesVideoParams(resProfiles){
				const root = resProfiles && resProfiles.data ? resProfiles.data : null;
				let profiles = [];
				try{
					if (root && root.profiles) {
						const pr = root.profiles;
						if (pr.converted && pr.converted.Body && pr.converted.Body.GetProfilesResponse && pr.converted.Body.GetProfilesResponse.Profiles) {
							profiles = pr.converted.Body.GetProfilesResponse.Profiles;
						}else if (pr.data && pr.data.GetProfilesResponse && pr.data.GetProfilesResponse.Profiles) {
							profiles = pr.data.GetProfilesResponse.Profiles;
						}else if (pr.data && pr.data.Body && pr.data.Body.GetProfilesResponse && pr.data.Body.GetProfilesResponse.Profiles) {
							profiles = pr.data.Body.GetProfilesResponse.Profiles;
						}else if (pr.GetProfilesResponse && pr.GetProfilesResponse.Profiles) {
							profiles = pr.GetProfilesResponse.Profiles;
						}else{
							const stack = [pr];
							while (stack.length) {
								const obj = stack.pop();
								if (!obj || typeof obj !== 'object') continue;
								if (obj.Profiles) { profiles = obj.Profiles; break; }
								Object.keys(obj).forEach(k => { if (obj[k] && typeof obj[k] === 'object') stack.push(obj[k]); });
							}
						}
					}else if (Array.isArray(root)) {
						profiles = root;
					}
				}catch(e){ profiles = []; }
				if (!profiles) profiles = [];
				if (!Array.isArray(profiles)) profiles = [profiles];

				const firstNonEmpty = (obj, paths) => {
					const getDeep = (o, pathArr) => {
						try{ let cur = o; for (let i=0;i<pathArr.length;i++){ if (cur==null) return undefined; cur = cur[pathArr[i]]; } return cur; }catch(e){ return undefined; }
					};
					for (const p of paths) {
						const v = getDeep(obj, p);
						if (v !== undefined && v !== null && v !== '') return v;
					}
					return undefined;
				};

				const result = [];
				profiles.forEach(p => {
					const encObj = firstNonEmpty(p, [
						['VideoEncoderConfiguration'],
						['tt:VideoEncoderConfiguration'],
						['video', 'encoder'],
					]) || {};
					const encoding = (firstNonEmpty(encObj, [
						['Encoding'],
						['$.Encoding'],
						['tt:Encoding'],
						['codec'],
					]) || '').toString();

					const resObj = firstNonEmpty(encObj, [
						['Resolution'],
						['tt:Resolution'],
					]) || {};
					const width  = parseInt(firstNonEmpty(resObj, [['Width'], ['tt:Width']]) || 0, 10) || 0;
					const height = parseInt(firstNonEmpty(resObj, [['Height'], ['tt:Height']]) || 0, 10) || 0;

					const rcObj = firstNonEmpty(encObj, [
						['RateControl'],
						['tt:RateControl'],
					]) || {};
					const fps     = parseInt(firstNonEmpty(rcObj, [['FrameRateLimit'], ['tt:FrameRateLimit'], ['fps']]) || 0, 10) || 0;
					const bitrate = parseInt(firstNonEmpty(rcObj, [['BitrateLimit'], ['tt:BitrateLimit'], ['bitrate']]) || 0, 10) || 0;

					result.push({ encoding, width, height, fps, bitrateKbps: bitrate });
				});
				return result;
			},
			async fetchOnvifInfoForDevice(dev){
				try{
					if (!dev) return;
					this.$set(dev, 'onvif_loading', true);
					const rtsp = dev.rtsp || '';
					const conn = this.extractConnFromRtsp(rtsp);
					if (!conn || !conn.host) {
						this.$set(dev, 'status_key', 'n_a');
						this.$set(dev, 'status_text', this.$ml.get('n_a'));
						this.$set(dev, 'status_color', 'secondary');
						this.$set(dev, 'config_text', this.$ml.get('n_a'));
						this.$set(dev, 'status_detail', { message: this.$ml.get('n_a') });
						this.$set(dev, 'onvif_loading', false);
						return;
					}
				const bodyConnection = { 
					connection : { 
						hostname: conn.host, 
						port: conn.port, 
						secure: conn.secure, 
						username: conn.username, 
						password: conn.password,
						rtsp1: dev.rtsp || '',
						rtsp2: dev.rtsp2 || ''
					} 
				};
				const baseURL = this.$URL;
				// Caso especial: cuando la RTSP no tiene usuario/clave y el host es dominio (RTSP Server),
				// enviar la RTSP completa en el payload para que el backend la utilice si es necesario.
				const isRtspServer = (!conn.username && !conn.password && conn.host && /[a-zA-Z]/.test(conn.host));
				const resProfiles = await fetchOnvifMediaProfiles(this.$axios, baseURL, bodyConnection, isRtspServer ? { rtsp } : undefined);
					const metas = this._parseProfilesVideoParams(resProfiles);
					const mainMeta = metas && metas.length > 0 ? metas[0] : null;
					const configText = this._formatOnvifVideoMeta(mainMeta);
					this.$set(dev, 'status_key', 'online');
					this.$set(dev, 'status_text', this.$ml.get('online'));
					this.$set(dev, 'status_color', 'success');
					this.$set(dev, 'config_text', configText || this.$ml.get('n_a'));
					this.$set(dev, 'status_detail', { message: this.$ml.get('ok'), status: 200, type: 'ONLINE' });
					this.$set(dev, 'onvif_loading', false);
				}catch(e){
					const detail   = (e && e.response && e.response.data) ? e.response.data : { message: (e && e.message) ? e.message : this.$ml.get('n_a') };
					const errType  = (detail && (detail.errType || detail.type)) ? String(detail.errType || detail.type) : 'ERROR';
					const errKey   = errType ? errType.toLowerCase() : 'error';
					const localizedText = this.$ml.get(errKey) || (detail && detail.message) || this.$ml.get('n_a');
					// Color por tipo
					let color = 'error';
					if (errKey.indexOf('auth') > -1) {
						color = 'warning';
					} else if (errKey.indexOf('offline') > -1) {
						color = 'error';
					}
					this.$set(dev, 'status_key', errKey);
					this.$set(dev, 'status_text', localizedText);
					this.$set(dev, 'status_color', color);
					this.$set(dev, 'config_text', this.$ml.get('n_a'));
					this.$set(dev, 'status_detail', {
						message : detail && detail.message ? detail.message : this.$ml.get('n_a'),
						status  : detail && detail.status  ? detail.status  : undefined,
						type    : errType,
						errType : errType
					});
					this.$set(dev, 'onvif_loading', false);
				}
			}, // fetch onvif info
			recive_info(val, from){

			}, // recive_info
			filterAllColumns(value, search, item){
				// Si no hay búsqueda, mostrar todos los items
				if (!search) return true;
				
				// Convertir búsqueda a minúsculas para comparación case-insensitive
				const searchLower = search.toString().toLowerCase();
				
				// Buscar en todas las columnas relevantes
				const searchableFields = [
					item.name,
					item.deviceId,
					item.type,
					item.ip,
					item.resolution,
					item.fps_display,
					item.codec,
					item.bitrate_display,
					item.deviceSn,
					item.device_sn,
					item.brand,
					item.model,
					item.host,
					item.username,
					item.workstation,
					item.limited,
					item.status_text,
					item.status_key
				];
				
				// Buscar en cada campo
				return searchableFields.some(field => {
					if (field === null || field === undefined) return false;
					return field.toString().toLowerCase().includes(searchLower);
				});
			}, // filter all columns
			actions(act, item){
				
				if (act == 'confirm_delete') {
					this.info_del = item;
					EventBus.$emit('notifications_modal', {
						type : 'confirm_delete',
						ID 	 : 'add_device'
					})
				}
				if (act == 'backup') {	
					this.actions_async('backup');
				}	
				if (act == 'restore_backup') {
					this.actions_async('restore_backup');
				}
				if (act == 'confirm_del_devices') {
					this.$EventBus.$emit('notifications_modal',{
						type : 'confirm_delete',
						ID 	 : 'add_device'
					});
				}
				
				
			}, // actions
			async actions_async(act){
				if (act == 'backup') {

				}
				if (act == 'restore_backup') {

				}

				if (act == 'delete_devices'){

				}
			}, // actions async

			redirect(url, type ){
				localStorage.setItem('type_Device', JSON.stringify(type));
				if (this.$route.name !== url) {
					this.$router.push({ name: url }).catch(err => {
						if (err.name !== 'NavigationDuplicated') throw err;
					});
				}
			}, // redirect

			async redirect_setting(item ){
				let inf_setting = item
				if (item && item.type === 'ACCESS_CONTROL' && item.deviceId) {
					try {
						const res = await AccessControlService.getDevice(item.deviceId)
						if (res && res.data) {
							inf_setting = { ...item, ...res.data, type: 'ACCESS_CONTROL' }
						} else if (!item.username || typeof item.hasPassword === 'undefined') {
							EventBus.$emit('notifications_modal', { type: 'warning', message: this.$ml.get('connection_error') || 'Connection Error' })
							return
						}
					} catch (e) {
						if (!item.username || typeof item.hasPassword === 'undefined') {
							EventBus.$emit('notifications_modal', { type: 'warning', message: this.$ml.get('connection_error') || 'Connection Error' })
							return
						}
					}
				}
				if (inf_setting && inf_setting.type === 'ACCESS_CONTROL') {
					inf_setting = sanitizeAccessControlDevice(inf_setting)
				}
				this.$Helper.set_local('settings_device',{ inf_setting });
				if (this.$route.name !== 'setting_device') {
					this.$router.push({ name: 'setting_device' }).catch(err => {
						if (err.name !== 'NavigationDuplicated') throw err;
					});
				}
			}, // redirect

			async get_list(page = 1, itemss = []){
				// Evitar llamadas múltiples simultáneas
				if (this.is_loading_list) {
					return;
				}
				
				// Evitar llamadas duplicadas para la misma página
				if (this.current_loading_page === page) {
					return;
				}
				
				// const { itemsPerPage, page } = this.options;
				const api 	 = this.$URL + '/api/v1/device/?page=' + page;
				this.loading = true;
				this.is_loading_list = true;
				this.current_loading_page = page;
				
				try {
					const res = await this.$axios.get(api);
					if (res && res.data && res.data.rows &&  res.data.rows.length > 0) {

						let items 	= itemss;
						items 		= items.concat(res.data.rows);
						if (page == 1) {
							if (res.data.count) {
								this.total 	 = res.data.count;
							}else{
								this.total 	 = res.data.rows.length;

							}
						}

						if (res.data.pages > page) {
							page++;
							await this.get_list(page, items);
						}else{

							await this.render_list_device(items)
						}
					}else{
						await this.render_list_device(itemss)
					}
					
					// Marcar que la carga inicial se completó solo cuando se termina de cargar la primera página
					if (page == 1) {
						this.initial_load_done = true;
					}
					
					this.loading = false;
					this.is_loading_list = false;
					this.current_loading_page = null;

				} catch (er) {
					this.loading = false;
					this.is_loading_list = false;
					this.current_loading_page = null;
					// Marcar como completado incluso si hay error para evitar bloqueos
					if (page == 1) {
						this.initial_load_done = true;
					}
					console.log(er, 'Error get_list');
				}


			}, // get list

			waitForStoreDevices() {
				return new Promise((resolve) => {
					// Verificar inmediatamente primero
					let devices = this.$store.getters["Devices/list"];
					if (devices && devices.length > 0) {
						resolve(devices);
						return;
					}
					
					// Si no hay datos, verificar cada 100ms si el store tiene datos
					let attempts = 0;
					const maxAttempts = 30; // 30 intentos * 100ms = 3 segundos máximo
					
					const checkInterval = setInterval(() => {
						attempts++;
						devices = this.$store.getters["Devices/list"];
						
						if (devices && devices.length > 0) {
							clearInterval(checkInterval);
							resolve(devices);
						} else if (attempts >= maxAttempts) {
							// Después de 3 segundos, dejar de intentar
							clearInterval(checkInterval);
							resolve(null);
						}
					}, 100);
				});
			}, // wait for store devices

			async get_relays_info(){
				try {
					const api = this.$URL + "/api/v1/mqtt/relays/info?timeout=2";
					const res = await this.$axios.get(api);
					
					// Estructura de respuesta: { success: true, data: { peripherals: [...] } }
					if (res && res.data && res.data.success && res.data.data && res.data.data.peripherals && Array.isArray(res.data.data.peripherals)) {
						return res.data.data.peripherals;
					}
					
					return [];
				} catch (er) {
					// Ignorar errores de "Request aborted" que ocurren durante hot reload o navegación
					if (er && er.message && er.message.includes('aborted')) {
						return [];
					}
					console.error("[get_relays_info] Error get relays info ", er);
					return [];
				}
			}, // get_relays_info

			async render_list_device(items){
				//console.log('[render_list_device] Iniciando procesamiento de', items?.length || 0, 'dispositivos');
				// Verificar si hay dispositivos iot_relay para actualizar después
				const hasIotRelay = items && items.some(dev => dev && dev.type === 'PERIPHERAL' && dev.type_peripheral === 'iot_relay');
				//console.log('[render_list_device] ¿Hay dispositivos iot_relay?', hasIotRelay);
				
				// Iniciar request de relays en paralelo sin bloquear la visualización
				if (hasIotRelay) {
					//console.log('[render_list_device] Iniciando consulta de relays en paralelo...');
					// No esperar, ejecutar en paralelo
					this.update_relays_info(items);
				}

				if (items && items.length > 0) {
					items.forEach((dev)=>{
						// Para dispositivos PERIPHERAL tipo iot_relay, establecer valores por defecto
						// La información se actualizará cuando llegue la respuesta del request de relays
						if (dev && dev.password) {
							delete dev.password;
						}
						if (dev && dev.type === 'ACCESS_CONTROL') {
							if (!dev.ip || dev.ip === '' || dev.ip === null) {
								dev.ip = dev.host || dev.deviceSn || dev.device_sn || this.$ml.get("n_a");
							}
							if (typeof dev.status_text === 'undefined') {
								this.$set(dev, 'status_text', dev.status || this.$ml.get('n_a'));
								this.$set(dev, 'status_color', dev.status ? 'success' : 'secondary');
							}
							if (typeof dev.status_key === 'undefined') {
								this.$set(dev, 'status_key', dev.status ? String(dev.status).toLowerCase() : 'n_a');
							}
						} else if (dev && dev.type === 'PERIPHERAL' && dev.type_peripheral === 'iot_relay') {
							// Establecer valores por defecto mientras se obtiene la información
							if (!dev.ip || dev.ip === '' || dev.ip === null) {
								if (dev.ip_machine) {
									dev.ip = dev.ip_machine;
								} else {
									dev.ip = this.$ml.get("n_a");
								}
							}
							// Marcar como cargando mientras se consulta el estado
							this.$set(dev, 'relay_loading', true);
							// Estado inicial mientras se consulta
							if (!dev.status_key || dev.status_key === 'n_a') {
								this.$set(dev, 'status_key', 'checking');
								this.$set(dev, 'status_text', this.$ml.get('checking') || 'Verificando...');
								this.$set(dev, 'status_color', 'info');
								this.$set(dev, 'relay_status', 'checking');
							}
						} else if (dev && dev.type === 'PERIPHERAL') {
							// Para otros dispositivos PERIPHERAL, usar ip si existe, sino usar ip_machine
							if (dev.ip && dev.ip !== '' && dev.ip !== null) {
								// Ya tiene un valor en ip, mantenerlo
							} else if (dev.ip_machine) {
								dev.ip = dev.ip_machine;
							} else {
								dev.ip = this.$ml.get("n_a");
							}
						} else {
							// Derivar SIEMPRE la IP visible desde RTSP (fallback a ip_machine)
							const rtspOrHls = dev && (dev.rtsp || dev.hls || '');
							const derived = this.extractIpFromRtsp(rtspOrHls);
							const connForDisplay = this.extractConnFromRtsp(rtspOrHls);
							// Si no hay usuario/clave y el host es un dominio, mostrar "server"
							if (connForDisplay && !connForDisplay.username && !connForDisplay.password && derived && /[a-zA-Z]/.test(derived)) {
								dev.ip = 'RTSP Server';
							} else if (derived) {
								dev.ip = derived;
							} else if (dev && dev.ip_machine) {
								dev.ip = dev.ip_machine;
							} else {
								dev.ip = this.$ml.get("n_a");
							}
						}
						if (dev.limit) {
							let temp_cap = 'mb';
							if (dev.capacity) {
								temp_cap = dev.capacity;
							}
							dev.limited = this.$Helper.convert_capacity(temp_cap, dev.limit, null, true) + ' ' + temp_cap.toUpperCase(); 
							dev.space 	= this.$ml.get('waiting_');


						}else{
							dev.limited = this.$ml.get('n_a');
							dev.space 	= this.$ml.get('n_a');

						}
						if (!dev.ip_machine) {
							if (dev.type == "IP_CAM") {
								dev.ip_machine = this.$ml.get("not_found");
							}else{
								dev.ip_machine = this.$ml.get("n_a");								
							}
						}
						if (dev.manager_id) {
							dev.workstation 		= this.$Format.get_name_workstation_by_manager_id(dev.manager_id);
							dev.color_workstation 	= dev.workstation == "N/A" ? "secondary" : "primary";
						}else{							
							dev.workstation 		= this.$ml.get("n_a");								
							dev.color_workstation 	= "secondary";

						}
						if (dev && dev.arduino && dev.arduino.length > 100) {
							dev.arduino = "";
						}

						// Inicializar columnas nuevas por defecto
						if (dev && typeof dev.status_text === 'undefined') {
							this.$set(dev, 'status_text', this.$ml.get('n_a'));
							this.$set(dev, 'status_color', 'secondary');
						}
						if (dev && typeof dev.status_key === 'undefined') {
							this.$set(dev, 'status_key', 'n_a');
						}
						if (dev && typeof dev.config_text === 'undefined') {
							this.$set(dev, 'config_text', this.$ml.get('n_a'));
						}
						if (dev && typeof dev.onvif_loading === 'undefined') {
							this.$set(dev, 'onvif_loading', false);
						}
						if (dev && typeof dev.status_detail === 'undefined') {
							this.$set(dev, 'status_detail', null);
						}
						// Inicializar campos de metadata para filtrado
						if (dev && typeof dev.resolution === 'undefined') {
							this.$set(dev, 'resolution', '');
						}
						if (dev && typeof dev.fps === 'undefined') {
							this.$set(dev, 'fps', null);
							this.$set(dev, 'fps_display', '');
						}
						if (dev && typeof dev.codec === 'undefined') {
							this.$set(dev, 'codec', '');
						}
						if (dev && typeof dev.bitrate === 'undefined') {
							this.$set(dev, 'bitrate', null);
							this.$set(dev, 'bitrate_display', '');
						}
						// Intentar obtener ONVIF meta si hay RTSP
						// DESHABILITADO: Funcionalidad ONVIF deshabilitada
						// if (dev && dev.rtsp) {
						// 	// espaciar llamadas para no saturar
						// 	this.$set(dev, 'onvif_loading', true);
						// 	setTimeout(() => this.fetchOnvifInfoForDevice(dev), 0);
						// }
					})

					items.sort(function(a,b){
					  // Turn your strings into dates, and then subtract them
					  // to get a value that is either negative, positive, or zero.
					  return    new Date(b.createdAt) - new Date(a.createdAt);
					});
					
					this.list 	 = [...items];
					this.listed  = [...items];
					this.actions("select_type_device")
				}
			}, // render list device

			async update_relays_info(items){
				// Esta función se ejecuta en paralelo para actualizar la información de relays
				//console.log('[update_relays_info] Iniciando actualización de información de relays...');
				try {
					const relaysInfo = await this.get_relays_info();
					//console.log('[update_relays_info] Relays info obtenida:', relaysInfo);
					
					// Buscar dispositivos iot_relay en la lista actual y actualizarlos
					const iotRelayDevices = this.list.filter(dev => 
						dev && dev.type === 'PERIPHERAL' && dev.type_peripheral === 'iot_relay'
					);
					
					if (!relaysInfo || relaysInfo.length === 0) {
						//console.log('[update_relays_info] No hay relays disponibles');
						// Marcar como completado aunque no haya relays
						iotRelayDevices.forEach((dev) => {
							this.$set(dev, 'relay_loading', false);
							if (dev.status_key === 'checking') {
								this.$set(dev, 'status_key', 'offline');
								this.$set(dev, 'status_text', this.$ml.get('offline') || 'No disponible');
								this.$set(dev, 'status_color', 'error');
								this.$set(dev, 'relay_status', 'offline');
							}
						});
						return;
					}
					
					iotRelayDevices.forEach((dev) => {
						// Obtener serial del dispositivo
						let deviceSerial = dev.serial;
						if (!deviceSerial && dev.relay) {
							if (typeof dev.relay === 'string') {
								try {
									const relayObj = JSON.parse(dev.relay);
									deviceSerial = relayObj.serial;
								} catch (e) {
									deviceSerial = dev.relay.serial;
								}
							} else if (dev.relay && dev.relay.serial) {
								deviceSerial = dev.relay.serial;
							}
						}
						
						if (deviceSerial) {
							const relayMatch = relaysInfo.find(r => String(r.serial) === String(deviceSerial));
							
							if (relayMatch) {
								// Guardar información de inputs y relays
								if (relayMatch.inputs) {
									this.$set(dev, 'relay_inputs_count', relayMatch.inputs.count || 0);
									this.$set(dev, 'relay_inputs_list', relayMatch.inputs.list || []);
								}
								if (relayMatch.relays) {
									this.$set(dev, 'relay_relays_count', relayMatch.relays.count || 0);
									this.$set(dev, 'relay_relays_list', relayMatch.relays.list || []);
								}
								
								if (relayMatch.ip) {
									dev.ip = relayMatch.ip;
									this.$set(dev, 'status_key', 'online');
									this.$set(dev, 'status_text', this.$ml.get('online') || 'Online');
									this.$set(dev, 'status_color', 'success');
									this.$set(dev, 'relay_status', 'online');
									this.$set(dev, 'relay_loading', false);
									//console.log('[update_relays_info] Actualizado', dev.name, '- IP:', dev.ip, '- Estado: Online');
								}
							} else {
								// Relay no encontrado en la red
								this.$set(dev, 'relay_loading', false);
								if (dev.ip && dev.ip !== '' && dev.ip !== null && dev.ip !== this.$ml.get("n_a")) {
									this.$set(dev, 'status_key', 'offline');
									this.$set(dev, 'status_text', this.$ml.get('offline') || 'No disponible');
									this.$set(dev, 'status_color', 'error');
									this.$set(dev, 'relay_status', 'offline');
									//console.log('[update_relays_info] Relay no encontrado para', dev.name, '- Estado: Offline');
								} else {
									this.$set(dev, 'status_key', 'unknown');
									this.$set(dev, 'status_text', this.$ml.get('unknown') || 'Desconocido');
									this.$set(dev, 'status_color', 'secondary');
									this.$set(dev, 'relay_status', 'unknown');
								}
							}
						} else {
							// No hay serial, marcar como completado
							this.$set(dev, 'relay_loading', false);
						}
					});
					
					//console.log('[update_relays_info] Actualización completada');
				} catch (er) {
					console.error('[update_relays_info] Error al actualizar información de relays:', er);
					// En caso de error, quitar el loading de todos los iot_relay
					const iotRelayDevices = this.list.filter(dev => 
						dev && dev.type === 'PERIPHERAL' && dev.type_peripheral === 'iot_relay'
					);
					iotRelayDevices.forEach((dev) => {
						this.$set(dev, 'relay_loading', false);
						if (dev.status_key === 'checking') {
							this.$set(dev, 'status_key', 'unknown');
							this.$set(dev, 'status_text', this.$ml.get('unknown') || 'Desconocido');
							this.$set(dev, 'status_color', 'secondary');
						}
					});
				}
			}, // update_relays_info

			del(item){
				if (item && item.id) {
					// console.log("CHECK LIST : *** ", this.list.indexOf(item), item)
					const api    = this.$URL + '/api/v1/device/' + item.id;
					this.loading = true;
					this.$axios.delete(api).then( res => {
						// console.log(res);
						this.list.splice(this.list.indexOf(item), 1);
						this.listed.splice(this.listed.indexOf(item), 1);
						this.$store.commit("Devices/delete_device", {...item });
						// this.$Helper.set_local("list_devices", this.listed);
            			// this.$Format.update_list('devices', this.listed);

						/*EventBus.$emit('render_modules', {
							name : 'delete_device',
							associate: item,
						})*/
						EventBus.$emit('notifications_modal',{
							type: 'deleted'
						});
						if (this.info_del) {
							this.info_del = null;
						}
						this.loading = false;
						// EventBus.$off('notifications_modal');
					}).catch( er => {
						console.log("Error del device ", er);
						this.loading = false;					
						this.$EventBus.$emit('notifications_modal',{
							type 	: 'error',
							message : er
						})
					})
				}else{
					/*this.$EventBus.$emit('notifications_modal',{
						type    : 'warning',
						message : this.$ml.get('no_found_id_del') 
					});*/
				}
			}, // del

		}, // methods
		computed: {
			render_list: function(){
				if (this.select_type_device != 'all') {
					let list_temp 	= this.list.filter(dev => {
							return dev.type == this.select_type_device;
						})
					// console.log("this listed ", this.listed)
					if (list_temp && list_temp.length === 0) {
						return [];
					}else{
						return list_temp;

					}
				}
				return this.listed;
			}, // render list

      		currentUser(){
      			return this.$store.state.auth.user;      			
      		}, // currentUser
			get_type_devices(){
				return this.type_devices.filter(device => device.enable == true)
			},

		}, // computed

		async mounted(){
			// Verificar si el store ya tiene datos
			const storeDevices = this.$store.getters["Devices/list"];
			
			if (storeDevices && storeDevices.length > 0) {
				// El store ya tiene datos, usarlos directamente
				this.render_list_device(storeDevices);
				this.total = storeDevices.length;
				this.initial_load_done = true;
			} else {
				// El store no tiene datos aún, esperar a que termine de cargar
				// El store se carga en App.vue al iniciar la aplicación
				// Esperamos hasta 3 segundos para que el store termine de cargar
				const storeDevicesAfterWait = await this.waitForStoreDevices();
					
				if (storeDevicesAfterWait && storeDevicesAfterWait.length > 0) {
					// Usar los dispositivos del store si se cargaron
					this.render_list_device(storeDevicesAfterWait);
					this.total = storeDevicesAfterWait.length;
					this.initial_load_done = true;
				} else {
					// Si después de esperar aún no hay datos, hacer la llamada
					// Esto solo ocurre si el usuario navega directamente a /device
					// sin pasar por el flujo normal de la aplicación
					this.get_list();
				}
			}
			
			let temp_bus = 'notifications_modal' + 'add_device';
			EventBus.$on(temp_bus, this.bus[temp_bus] =  (action) =>{
				if (action) {
					const info_dl = this.info_del;
					if (this.device_selecteds && this.device_selecteds.length > 0 && !info_del) {
						this.actions_async('delete_devices');
					}else{
						this.del(info_dl);
					}
					// EventBus.$off('render_modules');
				}
			});

			EventBus.$emit('connection_sq', {
			 	connection  : "space_devices",			 	
			});
			EventBus.$on('space_devices', this.bus['space_devices'] = (action)=>{
				if (action) {
					let idx = this.listed.findIndex( x => (x && x.deviceId == action.deviceId));
					// console.log("space_devices : ", action , idx)
					let temp_space = parseInt(action.space_use);
					if (idx >= 0) {

						if (temp_space > 100) {
							this.listed[idx].space   =  100 + '%';
						}else if (temp_space < 0) {
							this.listed[idx].space   =  0   + '%' ;
						}else{
							this.listed[idx].space   = temp_space + ' %';
						}
						 
						if (temp_space < 80) {
							this.listed[idx].space_color = 'primary';
						}else if (temp_space > 80 && temp_space < 95) {
							this.listed[idx].space_color = 'warning';
						}else{
							this.listed[idx].space_color = 'error';
						}
						if (temp_space > 0) {

							this.listed[idx].used = this.$Helper.convert_capacity('gb', action.totalSize, null, true) + "GB | " + this.$Helper.convert_capacity('mb', action.totalSize, null, true) + "MB";
						}else{
							this.listed[idx].used = "0 GB | 0 MB"; 
						}
					}
				}
			});

			// Listener para metadata de dispositivos
			EventBus.$on('event_metadata', this.bus['event_metadata'] = (message) => {
				if (message && message.deviceId) {
					this.handleMetadataUpdate(message);
				}
			});
	
		}, // mounted
		beforeDestroy(){
			let vm = this;
			for (let iter in vm.bus){
				if (vm.bus[iter]) {
					EventBus.$off(iter, vm.bus[iter]);
				}
			}
			// console.log("clear bus add device");
			EventBus.$emit('connection_sq', {
			 	connection  : "space_devices",			 	
			 	close 		: true
			});
		}, // before destroy
	};
</script>
